/**
 * RecommendationService
 *
 * @author Copyright (c) 2021 Salesforce.com.
 * @ownership Appexchange Everywhere
 */
import { RECOMMENDATION_SERVICE_URL } from '~/modules/config';
import { getPreferredLanguage } from '~/modules/helpers/languageHelper';
import { handleException } from '~/modules/utilities/error_utilities';
import { HttpRequestConfig, http } from '~/modules/utilities/http';
import { setupOrgRequestConfig } from '~/modules/utilities/httpUtilities';
import { SearchResult } from '../../schemas/search-schema-v1';
import { buildSearchResults } from '../helpers/searchServiceHelper';

const getApiEndpoint = (): string => {
    return RECOMMENDATION_SERVICE_URL;
};
const getRecommendationEndpoint = (): string => {
    return `${getApiEndpoint()}/v2/recommendations`;
};

const getSection = async (section: string, tbidToken: string): Promise<Array<SearchResult>> => {
    const endpoint: string = getRecommendationEndpoint();
    try {
        const encodedSection = encodeURIComponent(section);
        const language = getPreferredLanguage();
        const httpConfig: HttpRequestConfig = setupOrgRequestConfig();
        const recommendedListings = await http.get(
            `${endpoint}?type=${encodedSection}&language=${language}`,
            httpConfig,
        );
        return buildSearchResults(recommendedListings, { isRecommendedResult: true });
    } catch (error) {
        //TODO: handle errors so we don't cache empty data
        handleException(error, 'recommendationService.getSection');
        throw error;
    }
};

export { getSection };
